/**
 * @file コンポーネント：症例ラベルリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledList, StyledListItem, StyledListLabel } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledList>
            {props.labellist.map((label, index) => (
                <StyledListItem key={"label-" + index}>
                    {/*{label === "new" && (*/}
                    {/*    // New*/}
                    {/*    <StyledListLabel data-label="new">*/}
                    {/*        {localized["Label.LabelNew"]}*/}
                    {/*    </StyledListLabel>*/}
                    {/*)}*/}
                    {label === "paid" && (
                        // 有料コンテンツ
                        <StyledListLabel data-label="operation">
                            {localized["Label.LabelPaidContent"]}
                        </StyledListLabel>
                    )}
                    {label === "surgeon" && (
                        // 執刀医権限
                        <StyledListLabel data-label="editor">
                            {localized["Label.LabelSurgeonAuthority"]}
                        </StyledListLabel>
                    )}
                    {label === "point" && (
                        // ポイントコンテンツ
                        <StyledListLabel data-label="operation">
                            {localized["Label.LabelPointcontent"]}
                        </StyledListLabel>
                    )}
                </StyledListItem>
            ))}
        </StyledList>
    );
};
